import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import useCachedProductionCompanyList from '@src/adapters/hooks/productionCompany/useCachedProductionCompanyList';

interface Props {
  id: string;
}

function ProductionCompany({ id }: Props) {
  const { getList } = useCachedProductionCompanyList();
  const [display, setDisplay] = useState('');
  useEffect(() => {
    getList(id).then((company) => {
      if (company && company.length === 1) {
        setDisplay(company[0].name);
      }
    });
  }, [getList, id]);
  return <Box>{display}</Box>;
}

export default ProductionCompany;
